






























































import Vue from 'vue';
import ArrowUp from 'vue-material-design-icons/ArrowUpBold.vue';
import ArrowDown from 'vue-material-design-icons/ArrowDownBold.vue';

export default Vue.extend({
  components: {
    ArrowUp,
    ArrowDown,
  },
  props: {
    overallScore: {
      type: Number,
      required: true,
    },
    scoreChange: {
      type: Number,
      required: true,
    },
  },
});
